export default __webpack_public_path__ + "static/poele-combustion-lente-93bb123c295ee23c844c0c5290a97918.jpg";